<div class="card smaller configuration-panel-card">
  <div class="card-header">Basisdaten</div>
  <div class="card-body">
    <form class="k-form" [formGroup]="baseDataForm()">
      <kendo-formfield orientation="horizontal">
        <kendo-label text="Titel" [for]="title"></kendo-label>
        <kendo-textbox
          showErrorIcon="initial"
          [id]="formControlNames.Title"
          [formControlName]="formControlNames.Title"
          (valueChange)="formValueChanged([$event, formControlNames.Title])"
          #title
        >
        </kendo-textbox>
      </kendo-formfield>

      <kendo-formfield orientation="horizontal">
        <kendo-label [for]="invoiceDate" text="Rechnungsdatum"></kendo-label>
        <kendo-datepicker
          [formControlName]="formControlNames.InvoiceDate"
          (valueChange)="formValueChanged([$event, formControlNames.InvoiceDate])"
          #invoiceDate
        ></kendo-datepicker>
      </kendo-formfield>

      <kendo-formfield orientation="horizontal">
        <kendo-label [for]="dueDate" text="Zahlungsziel"></kendo-label>
        <kendo-datepicker
          [formControlName]="formControlNames.DueDate"
          (valueChange)="formValueChanged([$event, formControlNames.DueDate])"
          #dueDate
        ></kendo-datepicker>
      </kendo-formfield>
    </form>
  </div>
</div>
